import React from "react";
import { Link } from "react-router-dom";
import { useSidebar } from "../context/useSidebar";

export default function NotFound() {
  const { isSidebarOpen } = useSidebar();

  return (
    <div className={`content-body default-height ${isSidebarOpen ? "sidebar-open-page-margin" : "sidebar-close-page-margin"}`}>
      <div className="container-fluid">
        <div class="row justify-content-center align-items-center">
          <div class="col-md-6">
            <div class="form-input-content text-center error-page">
              <h1 class="error-text font-weight-bold">404</h1>
              <h4>
                <i class="fa fa-exclamation-triangle text-warning"></i> The page you were looking for is not found!
              </h4>
              <p>You may have mistyped the address or the page may have moved.</p>
              <div>
                <Link class="btn btn-primary" to="/">
                  Back to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
